// extracted by mini-css-extract-plugin
export var background = "_67-0";
export var container = "_67-1";
export var contentItem = "_67-7";
export var extendedWarranty = "_67-5";
export var link = "_67-d";
export var modal = "_67-b";
export var modalCloseButton = "_67-9";
export var modalContent = "_67-3";
export var modalContentMain = "_67-6";
export var modalImageLogo = "_67-8";
export var modalLogo = "_67-a";
export var modalSideImage = "_67-4";
export var preview = "_67-c";
export var redoModal = "_67-2";